import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

interface Material {
  category: string;
  material: string;
  requiredQty: number;
  uom: string;
  leadTime: number;
  expectedDeliveryDate: string;
  priority: string;
  status: string;
  remarks: string;
}

interface Activity {
  id: number;
  name: string;
  qty: number;
  uom: string;
  milestone: string;
  materials: Material[];
}

@Component({
  selector: 'app-material-delivary',
  templateUrl: './material-delivary.component.html',
  styleUrls: ['./material-delivary.component.scss'],
  imports: [
    MatIconModule
  ]
})
export class MaterialDelivaryComponent implements OnInit {

  clientName = 'L&T';
  projectName = 'Metro Rail Project';
  woNumber = 'WO-2026-0014';
  scheduleRefNo = 'MDS-2026-001';

  activities: Activity[] = [
    {
      id: 1,
      name: 'Pump Room',
      qty: 250,
      uom: 'Cum',
      milestone: 'MS-001',
      materials: [
        {
          category: 'Civil Material',
          material: 'Sand',
          requiredQty: 250,
          uom: 'Cum',
          leadTime: 5,
          expectedDeliveryDate: '',
          priority: 'High',
          status: 'Planned',
          remarks: 'Required before excavation'
        },
        {
          category: 'Civil Material',
          material: 'Aggregate',
          requiredQty: 150,
          uom: 'Cum',
          leadTime: 4,
          expectedDeliveryDate: '',
          priority: 'Medium',
          status: 'Planned',
          remarks: 'Secondary material'
        }
      ]
    },
    {
      id: 2,
      name: 'Hydrent',
      qty: 1200,
      uom: 'Sqft',
      milestone: 'MS-002',
      materials: [
        {
          category: 'Civil Material',
          material: 'Cement',
          requiredQty: 500,
          uom: 'Bags',
          leadTime: 7,
          expectedDeliveryDate: '',
          priority: 'High',
          status: 'Planned',
          remarks: 'Before PCC'
        }
      ]
    }
  ];

  constructor() { }

  ngOnInit(): void { }

  // Add new Activity
  addActivity() {
    const newId = this.activities.length + 1;
    this.activities.push({
      id: newId,
      name: 'New Activity',
      qty: 0,
      uom: 'Cum',
      milestone: `MS-00${newId}`,
      materials: []
    });
  }

  // Delete Activity
  deleteActivity(index: number) {
    this.activities.splice(index, 1);
  }

  // Add Material to Activity
  addMaterial(activityIndex: number) {
    const activity = this.activities[activityIndex];
    activity.materials.push({
      category: 'Civil Material',
      material: '',
      requiredQty: 0,
      uom: 'Cum',
      leadTime: 0,
      expectedDeliveryDate: '',
      priority: 'Medium',
      status: 'Planned',
      remarks: ''
    });
  }

  // Delete Material
  deleteMaterial(activityIndex: number, materialIndex: number) {
    this.activities[activityIndex].materials.splice(materialIndex, 1);
  }

  // Save (for demo)
  saveSchedule() {
    console.log('Saving Schedule...', this.activities);
    alert('Schedule Saved Successfully! (Check console)');
  }
}